import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {BottomSheet} from "react-spring-bottom-sheet";
import Sheet from 'react-modal-sheet';
import Draggable from "react-draggable-bottom-sheet";

import './ButtomSheet.scss';
import styles from './MyOrderMobile.module.scss';
import cart from '../../../constants/images/myOrderIcons/cleaning-cart.svg';
import geo from "../../../constants/images/myOrderIcons/geo-location-icon.svg";
import tag from "../../../constants/images/myOrderIcons/tag-icon.svg";
import creditCard from "../../../constants/images/myOrderIcons/credit-card.svg";
import clock from "../../../constants/images/myOrderIcons/date-clock.svg";
import myOrder from "../../../constants/images/my-order-default.svg";
import AppAccordion from "../../UI/AppAccordion/AppAccordion";

const MyOrderMobile = () => {
    const [isOpen, setIsOpen] = useState(false);

    const {
        finalPrice,
        selectedCity,
        street,
        buildingNumber,
        entrance,
        apartment,
        service_package,
        services,
        selectedDate,
        selectedTime,
        request_datetime,
        request_price
    } = useSelector(state => state.stepperInfo);

    return (
        <>
            <div
                onClick={() => setIsOpen(true)}
                className={styles.myOrderMobile}
            >
                <div className={styles.myOrderMobile_divider}></div>
                <div className={styles.myOrderMobile_order}>
                    <img src={cart} alt="cart icon"/>
                    <div className={styles.myOrderMobile_order_price}>
                        <p>Моє замовлення</p>
                        <p>Від ₴{finalPrice}</p>
                    </div>
                </div>
            </div>

            {/*<button onClick={() => setIsOpen(true)}>Open sheet</button>*/}

            {/*<Draggable isOpen={isOpen} close={() => setIsOpen(false)}>*/}
            {/*    <div style={{ textAlign: "left", padding: "0px 16px 16px 16px" }}>*/}
            {/*        <h2>Hey! What's up??</h2>*/}
            {/*        <p>You can add </p>*/}
            {/*        <p>As much</p>*/}
            {/*        <p>Content</p>*/}
            {/*        <p>As you need</p>*/}
            {/*        <p>in here</p>*/}
            {/*    </div>*/}
            {/*</Draggable>*/}

            <Sheet
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                // detent={'content-height'}
                snapPoints={[650]}
            >
                <Sheet.Container>
                    <Sheet.Header/>
                    <Sheet.Content>
                        <div className={styles.myOrder}>
                            <h2 className={styles.myOrder_title}>Моє замовлення</h2>
                            {
                                ((!!selectedCity || (!!street || !!buildingNumber || !!apartment || !!entrance) || !!service_package?.name || services?.length > 0)) ?
                                    <div className={styles.myOrder_info}>
                                        {
                                            (selectedCity || (!!street || !!buildingNumber || !!apartment || !!entrance)) &&
                                            <div className={styles.myOrder_info_addressContainer}>
                                                <div className={styles.myOrder_info_addressContainer_icon}>
                                                    <img src={geo} alt="geo location icon"/>
                                                </div>

                                                <div className={styles.myOrder_info_addressContainer_address}>
                                                    <p>{`${street}, буд. ${buildingNumber}, під. ${entrance}, кв. ${apartment}`}</p>
                                                    <p>{selectedCity}</p>
                                                </div>
                                            </div>
                                        }

                                        {
                                            (!!service_package?.name) &&
                                            <div className={styles.myOrder_info_package}>
                                                <div className={styles.myOrder_info_package_icon}>
                                                    <img src={tag} alt="tag icon"/>
                                                </div>

                                                <div className={styles.myOrder_info_package_services}>
                                                    {
                                                        (service_package?.name === 'Індивідуальний пакет') ?
                                                            service_package?.name :
                                                            <AppAccordion
                                                                type={'Назва пакету'}
                                                                title={service_package?.name}
                                                            />
                                                    }
                                                </div>
                                            </div>
                                        }

                                        {
                                            (services?.length > 0) &&
                                            <div className={styles.myOrder_info_additionalServices}>
                                                <div className={styles.myOrder_info_additionalServices_icon}>
                                                    <img src={cart} alt="cart icon"/>
                                                </div>

                                                <div className={styles.myOrder_info_additionalServices_services}>
                                                    {
                                                        <AppAccordion
                                                            type={'Додаткові послуги'}
                                                            title={'Додаткові послуги'}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        }

                                        {(finalPrice > 0) &&
                                            <div className={styles.myOrder_info_price}>
                                                <div className={styles.myOrder_info_price_icon}>
                                                    <img src={creditCard} alt="credit card icon"/>
                                                </div>

                                                <div className={styles.myOrder_info_price_finalPrice}>
                                                    <p>Орієнтовна вартість</p>
                                                    <p>₴{finalPrice}</p>
                                                </div>
                                            </div>}

                                        {!!request_price &&
                                            <div className={styles.myOrder_info_price}>
                                                <div className={styles.myOrder_info_price_icon}>
                                                    <img src={creditCard} alt="credit card icon"/>
                                                </div>

                                                <div className={styles.myOrder_info_price_finalPrice}>
                                                    <p>Ви пропонуєте</p>
                                                    <p>₴{request_price}</p>
                                                </div>
                                            </div>}

                                        {
                                            (selectedDate || selectedTime) &&
                                            <div className={styles.myOrder_info_dateAndTime}>
                                                <div className={styles.myOrder_info_dateAndTime_icon}>
                                                    <img src={clock} alt="clock icon"/>
                                                </div>

                                                <div className={styles.myOrder_info_dateAndTime_dateAndTime}>
                                                    <p>{new Date(request_datetime).toLocaleDateString()}</p>
                                                    <p>{selectedTime}</p>
                                                </div>
                                            </div>
                                        }
                                    </div> :
                                    <>
                                        <img className={styles.myOrder_icon} src={myOrder} alt="my order icon"/>
                                        <div className={styles.myOrder_description}>
                                            <p>Привіт!</p>
                                            <p>Ми чекаємо вашого замовлення, щоб потурбуватись про вашу чистоту.</p>
                                        </div>
                                    </>
                            }
                        </div>
                    </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop/>
            </Sheet>
        </>
    );
};

export default MyOrderMobile;
